import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=447d8bee&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=447d8bee&prod&scoped=true&lang=css"
import style1 from "./PaymentSettings.vue?vue&type=style&index=1&id=447d8bee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d8bee",
  null
  
)

export default component.exports